/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { CKEditor5, EditorType } from '@ckeditor/ckeditor5-metadata';

// In run-time, these packages are injected via CDN (`script[type=importmap]`).
import * as ckeditor5 from 'ckeditor5';

type EditorClass =
	typeof CKEditor5.ClassicEditor |
	typeof CKEditor5.InlineEditor |
	typeof CKEditor5.BalloonEditor |
	typeof CKEditor5.DecoupledEditor;

export function getEditorClassByType( editorType: EditorType ): EditorClass {
	switch ( editorType ) {
		case 'ClassicEditor':
			return ckeditor5.ClassicEditor;
		case 'InlineEditor':
			return ckeditor5.InlineEditor;
		case 'BalloonEditor':
			return ckeditor5.BalloonEditor;
		case 'DecoupledEditor':
			return ckeditor5.DecoupledEditor;
	}
}
